// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalBodyWithSidebarLayout_wrapper__LbAhy","sidebar":"ModalBodyWithSidebarLayout_sidebar__+Dfhs","content":"ModalBodyWithSidebarLayout_content__Hya4+"};